import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ContentColor = styled('div')`
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;

  div {
    display: flex;
    flex-direction: row;
    flex-grow: initial;
    flex-wrap: wrap;
  }

  div.space-between {
    justify-content: space-between;
    width: 100%;
    align-items: center;
    margin-bottom: ${theme.spacing.xm};
  }

  div.box-amount {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: ${theme.spacing.sm};

    h2 {
      margin: 0;
      color: ${theme.colors.neutral.black};
      font-size: ${theme.typography.sizes.xs};
      font-weight: ${theme.typography.weight.lg};
    }
    p {
      margin: 0;
      color: ${theme.colors.neutral.high};
      font-size: ${theme.typography.sizes.sm};
      font-weight: ${theme.typography.weight.xsm};
      margin-bottom: ${theme.spacing.sm};
    }
    #sizes-label {
      margin-top: ${theme.spacing.xm};
    }
  }

  div.column {
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.spacing.xm};
    margin-right: ${theme.spacing.xm};
  }
  div.bottom {
    background: blue;
    margin-bottom: ${theme.spacing.xm};
  }

  h3 {
    color: ${theme.colors.secondary};
    font-family: ${theme.typography.family.primary};
    font-size: ${theme.typography.sizes.md};
    font-weight: ${theme.typography.weight.md};
    margin: 0;
  }

  #subtotal {
    color: ${theme.colors.neutral.medium};
    font-family: ${theme.typography.family.primary};
    font-weight: ${theme.typography.weight.lg};
    font-size: ${theme.typography.sizes.xs};
    margin: 0;
  }

  span {
    color: ${theme.colors.neutral.medium};
    font-family: ${theme.typography.family.primary};
    font-weight: ${theme.typography.weight.lg};
    font-size: ${theme.typography.sizes.sm};
    text-transform: ${theme.typography.decoration.uppercase};
  }

  hr {
    border-top: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.lighthover};
    border-right: none;
    border-bottom: none;
    border-left: none;
    margin-top: 0;
    margin-bottom: ${theme.spacing.xm};
    width: 100%;
  }
`

type ContentControlsProps = {
  globalLoading?: boolean
}

export const ContentControls = styled.div<ContentControlsProps>`
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.sm};
  padding: ${theme.spacing.xm};
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  box-shadow: ${theme.effects.boxShadow['rule-01']};
  border: 1px solid ${theme.colors.neutral.lighthover};

  .hiden-icon-tooltip {
    position: relative;
    div:first-of-type {
      position: absolute;
      height: 100%;
      width: 100%;
      right: 0;
      top: 0;
      svg {
        height: 100%;
        width: 100%;
        opacity: 0;
      }
      cursor: ${({ globalLoading }) => (!globalLoading ? 'pointer' : 'wait')};
    }
  }
`
